(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("defclass"), require("lodash.defaults"), require("lodash.isfunction"), require("lodash.isobject"), require("lodash.memoize"));
	else if(typeof define === 'function' && define.amd)
		define(["defclass", "lodash.defaults", "lodash.isfunction", "lodash.isobject", "lodash.memoize"], factory);
	else if(typeof exports === 'object')
		exports["te-flow"] = factory(require("defclass"), require("lodash.defaults"), require("lodash.isfunction"), require("lodash.isobject"), require("lodash.memoize"));
	else
		root["te-flow"] = factory(root["defclass"], root["lodash.defaults"], root["lodash.isfunction"], root["lodash.isobject"], root["lodash.memoize"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition